import React, { useState, useEffect } from 'react';
import Button from 'shared/lib/components/Button';
import TextInput from 'shared/lib/components/TextInput';
import useTokenExchange from '../../services/useTokenExchange';
import axios from 'axios';
import get from 'lodash/get';
import { CardElement } from '@stripe/react-stripe-js';
import './UpdatePaymentMethodV2.css';
import { Link } from 'shared/lib/SureDesignSystem';
import styles from './CheckoutFormV2.module.css';
import { logException } from 'shared/lib/utils';
import Spinner from 'shared/lib/components/Spinner';
const host = process.env.REACT_APP_API_V2;
const axiosOverride = axios.create();
axiosOverride.defaults.baseURL = process.env.REACT_APP_SURE_API_BASE_URL;

function getPolicy(policyId, authToken) {
  return new Promise((resolve, reject) => {
    axiosOverride
      .get(`${host}/api/v2/policies/${policyId}/?include=payment-method`, {
        headers: {
          'X-Space': 'sure',
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then(response => {
        return resolve(response);
      })
      .catch(error => reject(error));
  });
}

function CheckoutFormV2(props) {
  const [cardName, setCardName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [clientEmail, setClientEmail] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [tokenFailure, setTokenFailure] = useState(false);
  const [isLoadingView, setIsLoadingView] = useState(true);
  const [authToken, setAuthToken] = useState('');
  const { location, elements, onSuccess, policyId, stripe } = props;

  useEffect(() => {
    useTokenExchange(location.query.token)
      .then(response => {
        setAuthToken(response.data.token);
        const curToken = response.data.token;

        if (curToken) {
          getPolicy(policyId, curToken).then(res => {
            setClientEmail(res.data.client.email);
            setPaymentMethod(res.data.payment_method.id);
          });
        }
        setIsLoadingView(false);
      })
      .catch(error => {
        setIsLoadingView(false);
        setTokenFailure(true);
        logException(error);

        return;
      });
  }, []);

  const handleFieldChange = e => {
    setCardName(e.target.value);
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    setError(null);
    setIsSubmitting(true);

    const cardElement = elements.getElement(CardElement);

    stripe
      .createToken(cardElement, {
        name: cardName,
        address_country: 'US',
      })

      .then(result => {
        if (result.error) {
          throw new Error(result.error.message);
        } else {
          return axiosOverride.put(
            `${host}/api/v2/policies/${policyId}/payment-method/${paymentMethod}/`,
            {
              name: cardName,
              email: clientEmail,
              payment_method_type: 'card',
              source_token: result.token.id,
            },
            {
              headers: {
                'X-Space': 'sure',
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
        }
      })
      .then(() => {
        setIsSubmitting(false);
        onSuccess();
      })
      .catch(error => {
        setIsSubmitting(false);
        setError(
          get(error, 'response.data.error.message') || get(error, 'message')
        );
      });
  };

  return isLoadingView ? (
    <div className={styles.loader}>
      <Spinner />
    </div>
  ) : tokenFailure ? (
    <>
      <h2>
        There was an error with your link. Please login{' '}
        <a className={styles.loginLink} href="/login">
          here
        </a>{' '}
        to update your payment method from your account settings or contact our
        support team if you need further assistance.{' '}
      </h2>
      <div className={styles.linksColumn}>
        <div className={styles.linksColumnItems}>
          <span>
            Phone:{' '}
            <Link href="tel:(844) 335-5441" className={styles.linksColumnItem}>
              (844) 335-5441
            </Link>
          </span>
          <span>
            Email:{' '}
            <Link
              href="mailto:support@sureapp.com"
              className={styles.linksColumnItem}
              target="_blank"
              rel="noopener nofollow"
            >
              support@sureapp.com
            </Link>
          </span>
          <span>Mon - Fri | 8am - 5pm PST</span>
        </div>
      </div>
    </>
  ) : (
    <>
      <h1>Update Your Payment Method</h1>
      <form onSubmit={handleSubmit}>
        {error && <div className="UpdatePaymentMethod-error">{error}</div>}
        <TextInput
          name="cardName"
          id="cardName"
          className="UpdatePaymentMethod-nameInput"
          required
          type="text"
          placeholder="Name on card"
          onChange={handleFieldChange}
          value={cardName}
          pattern="^(?!.*\d)[a-zA-Z\-][a-zA-Z\s\-]*[a-zA-Z]$"
          maxLength={60}
          title="Names cannot include numbers, special characters, or trailing / leading spaces"
        />

        <div className="UpdatePaymentMethod-cardWrapper">
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#00345c',
                  '::placeholder': {
                    color: '#aab7c4',
                  },
                },
                invalid: {
                  color: '#9e2146',
                },
              },
            }}
          />
        </div>
        <Button type="submit" disabled={!stripe || isSubmitting}>
          Submit
        </Button>
      </form>
    </>
  );
}

export default CheckoutFormV2;
